import './index.css';
import React from 'react';
import View from '../view';
import Text from '../view';
import useTheme from '../../utilities/hooks/theme';

type Props = {
  stateName: Object;
};

const RestrictionMessage = ({ stateName = '' }: Props) => {
  const { ComponentTheme: theme } = useTheme();
  const restrictionMessage = {
    color: theme.restrictionMessageTitle
  };
  let message = 'Sorry, this game is not playable in your location ';
  message += stateName ? `"${stateName}".` : '.';
  return (
    <View className={'restriction-message-container'}>
      <Text style={restrictionMessage} className={'restriction-message-title'}>
        {`${message}`}
      </Text>
    </View>
  );
};

export default React.memo(RestrictionMessage);
